<template>
  <div>
    <div class="ch-head">
      <div>
        <h1>数据资产</h1>
        <p>这里是已勾选同意共享的会员在创作中心做出的作品，不要求发布到门户。可以按作品名称、会员或手机号搜索，只能查看和下载。</p>
      </div>
    </div>
    <div class="ch-panel">
      <div class="ch-filters">
        <label>会员
          <select v-model="userId" @change="reload">
            <option value="">全部会员</option>
            <option v-for="row in members" :key="row.userId" :value="String(row.userId)">{{ row.nickname || ('会员' + row.userId) }}</option>
          </select>
        </label>
        <label>搜索
          <input v-model="keyword" placeholder="作品名称 / 会员 / 手机" @keyup.enter="reload" />
        </label>
        <label>类型
          <select v-model="workType" @change="reload">
            <option value="">全部</option>
            <option value="1">视频</option>
            <option value="2">图片</option>
            <option value="3">剧本</option>
          </select>
        </label>
        <label>排序
          <select v-model="sortKey" @change="applySort">
            <option value="createdAt:desc">最新创作</option>
            <option value="createdAt:asc">最早创作</option>
            <option value="member:asc">按会员</option>
            <option value="workType:asc">按类型</option>
          </select>
        </label>
        <button class="ch-btn" type="button" @click="reload">查询</button>
        <button class="ch-btn" type="button" @click="reset">重置</button>
      </div>
      <div v-if="list.length" class="asset-grid">
        <article v-for="row in list" :key="row.id" class="asset-card" @click="open(row)">
          <div class="cover">
            <img v-if="imageCover(row)" :src="imageCover(row)" :alt="row.title" @error="hideCover(row)" />
            <video v-else-if="Number(row.workType) === 1 && row.videoUrl" :src="row.videoUrl" muted />
            <div v-else class="cover-empty">{{ typeText(row.workType) }}</div>
            <span class="badge" :class="badgeClass(row)">{{ badgeText(row) }}</span>
          </div>
          <div class="card-body">
            <h3>{{ row.title || '未命名作品' }}</h3>
            <div class="card-meta">
              <span class="who"><i>{{ initial(row) }}</i>{{ row.nickname || ('会员' + row.userId) }}</span>
              <span class="when">{{ dayText(row.createdAt) }}</span>
              <button class="enter" type="button" @click.stop="open(row)">查看</button>
              <button v-if="downloadUrl(row)" class="enter download" type="button" @click.stop="download(row)">下载</button>
            </div>
          </div>
        </article>
      </div>
      <p v-else class="ch-empty">{{ keyword.trim() ? '没有匹配的作品' : '名下会员在创作中心还没有作品' }}</p>
      <div class="pager" v-if="total">
        <button class="ch-btn" type="button" :disabled="page <= 1" @click="go(page - 1)">上一页</button>
        <span>第 {{ page }} / {{ pages }} 页，共 {{ total }} 个</span>
        <button class="ch-btn" type="button" :disabled="page >= pages" @click="go(page + 1)">下一页</button>
      </div>
    </div>
    <el-dialog :title="preview.title || '作品'" :visible.sync="preview.open" width="720px" append-to-body>
      <div class="preview">
        <img v-if="preview.image" :src="preview.image" :alt="preview.title" />
        <video v-else-if="preview.video" :src="preview.video" controls autoplay />
        <p v-else class="ch-empty">这个作品还没有可预览的画面</p>
        <p class="preview-note">{{ preview.note }}</p>
        <button v-if="preview.download" class="ch-btn" type="button" @click="downloadPreview">下载原文件</button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getEcoMembers, getEcoWorks } from '@/api/admin'

export default {
  name: 'PartnerWorks',
  data() {
    return {
      members: [],
      list: [],
      total: 0,
      page: 1,
      pageSize: 20,
      userId: '',
      workType: '',
      keyword: '',
      sort: 'createdAt',
      order: 'desc',
      sortKey: 'createdAt:desc',
      broken: {},
      preview: { open: false, title: '', image: '', video: '', download: '', note: '' }
    }
  },
  computed: {
    pages() {
      return Math.max(1, Math.ceil(this.total / this.pageSize))
    }
  },
  created() {
    this.loadMembers()
    this.load()
  },
  methods: {
    async loadMembers() {
      const result = await getEcoMembers({ page: 1, pageSize: 50 })
      this.members = (result && result.list) || []
    },
    async load() {
      const result = await getEcoWorks({
        page: this.page,
        pageSize: this.pageSize,
        sort: this.sort,
        order: this.order,
        userId: this.userId || undefined,
        workType: this.workType || undefined,
        keyword: this.keyword.trim() || undefined
      })
      this.list = (result && result.list) || []
      this.total = Number((result && result.total) || 0)
    },
    reload() {
      this.page = 1
      this.load()
    },
    reset() {
      this.userId = ''
      this.keyword = ''
      this.workType = ''
      this.sort = 'createdAt'
      this.order = 'desc'
      this.sortKey = 'createdAt:desc'
      this.reload()
    },
    go(page) {
      this.page = page
      this.load()
    },
    applySort() {
      const parts = String(this.sortKey || 'createdAt:desc').split(':')
      this.sort = parts[0] || 'createdAt'
      this.order = parts[1] || 'desc'
      this.reload()
    },
    imageCover(row) {
      if (this.broken[row.id]) return ''
      if (Number(row.workType) === 2 && row.videoUrl && !this.isVideoFile(row.videoUrl)) return row.videoUrl
      const cover = row.coverUrl || ''
      if (cover && !this.isVideoFile(cover)) return cover
      return ''
    },
    hideCover(row) {
      if (row && row.id) this.$set(this.broken, row.id, true)
    },
    isVideoFile(url) {
      return /\.(mp4|webm|mov)(\?|$)/i.test(String(url || ''))
    },
    downloadUrl(row) {
      if (!row) return ''
      const type = Number(row.workType)
      if (type === 1 || type === 2) return row.videoUrl || ''
      return ''
    },
    fileName(row, url) {
      const title = String((row && row.title) || '作品').replace(/[\\/:*?"<>|]/g, '_')
      const path = String(url || '').split('?')[0]
      const ext = (path.match(/\.([a-z0-9]+)$/i) || [])[1]
      const type = Number(row && row.workType)
      const fallback = type === 1 ? 'mp4' : (type === 2 ? 'png' : 'bin')
      return title + '.' + (ext || fallback)
    },
    async download(row) {
      const url = this.downloadUrl(row)
      if (!url) {
        this.$message.warning('这个作品没有可下载的图片或视频')
        return
      }
      const name = this.fileName(row, url)
      try {
        const response = await fetch(url, { mode: 'cors' })
        if (!response.ok) throw new Error('download failed')
        const blob = await response.blob()
        const objectUrl = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = objectUrl
        link.download = name
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(objectUrl)
      } catch (e) {
        const link = document.createElement('a')
        link.href = url
        link.target = '_blank'
        link.rel = 'noopener'
        link.download = name
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
    },
    downloadPreview() {
      if (!this.preview.download) return
      this.download({
        title: this.preview.title,
        workType: this.preview.video ? 1 : 2,
        videoUrl: this.preview.download
      })
    },
    open(row) {
      const image = this.imageCover(row)
      const video = Number(row.workType) === 1 ? (row.videoUrl || '') : ''
      const download = this.downloadUrl(row)
      this.preview = {
        open: true,
        title: row.title || '未命名作品',
        image: video ? '' : image,
        video,
        download,
        note: this.memberLine(row)
      }
    },
    memberLine(row) {
      const who = row.nickname || ('会员' + row.userId)
      return who + ' · ' + this.dayText(row.createdAt) + ' · ' + this.typeText(row.workType)
    },
    initial(row) {
      const name = row.nickname || '会'
      return String(name).slice(0, 1)
    },
    badgeText(row) {
      const status = String(row.status || '').toUpperCase()
      if (Number(row.workType) === 3) {
        if (status === 'IN_PROGRESS') return '制作中'
        if (status === 'COMPLETED') return '已完成'
        if (status === 'ARCHIVED') return '已归档'
        return '剧本'
      }
      if (status === 'FAILED') return '失败'
      return this.typeText(row.workType)
    },
    badgeClass(row) {
      const status = String(row.status || '').toUpperCase()
      if (status === 'IN_PROGRESS') return 'progress'
      if (status === 'COMPLETED') return 'done'
      if (status === 'FAILED') return 'failed'
      if (Number(row.workType) === 3) return 'script'
      return 'media'
    },
    typeText(type) {
      if (Number(type) === 2) return '图片'
      if (Number(type) === 1) return '视频'
      if (Number(type) === 3) return '剧本'
      if (Number(type) === 0) return '其他'
      return '—'
    },
    dayText(value) {
      if (!value) return '—'
      const text = String(value).replace('T', ' ')
      const match = text.match(/(\d{4})-(\d{2})-(\d{2})/)
      if (!match) return text.slice(0, 10)
      return Number(match[1]) + '/' + Number(match[2]) + '/' + Number(match[3])
    }
  }
}
</script>

<style scoped>
.pager { display: flex; align-items: center; gap: 12px; margin-top: 14px; color: #5c6780; font-size: 13px; }
select, input { margin-left: 8px; height: 32px; border: 1px solid #d9dfec; border-radius: 8px; padding: 0 8px; }
input { width: 220px; }
.asset-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(240px, 1fr)); gap: 16px; }
.asset-card { background: #171d2b; border-radius: 12px; overflow: hidden; cursor: pointer; color: #fff; }
.cover { position: relative; aspect-ratio: 16 / 10; background: #10141d; }
.cover img, .cover video { width: 100%; height: 100%; object-fit: cover; display: block; }
.cover-empty { height: 100%; display: flex; align-items: center; justify-content: center; color: rgba(255,255,255,.45); font-size: 14px; }
.badge { position: absolute; top: 10px; left: 10px; border-radius: 6px; padding: 3px 8px; font-size: 12px; font-weight: 650; color: #fff; }
.badge.progress, .badge.media { background: rgba(56, 189, 248, .9); }
.badge.script { background: rgba(56, 189, 248, .9); }
.badge.done { background: rgba(45, 212, 191, .92); }
.badge.failed { background: rgba(248, 113, 113, .92); }
.card-body { padding: 12px 12px 10px; }
.card-body h3 { margin: 0 0 10px; font-size: 15px; font-weight: 650; line-height: 1.4; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.card-meta { display: flex; align-items: center; gap: 8px; color: rgba(255,255,255,.72); font-size: 12px; }
.who { display: inline-flex; align-items: center; gap: 6px; min-width: 0; }
.who i { width: 18px; height: 18px; border-radius: 50%; background: #2fbf71; color: #fff; font-style: normal; font-size: 11px; display: inline-flex; align-items: center; justify-content: center; flex: none; }
.when { margin-left: auto; white-space: nowrap; }
.enter { border: 0; border-radius: 6px; background: #2fbf71; color: #fff; height: 26px; padding: 0 8px; cursor: pointer; font-size: 12px; flex: none; }
.enter.download { background: #3b82f6; }
.preview img, .preview video { width: 100%; max-height: 460px; object-fit: contain; background: #10141d; border-radius: 8px; display: block; }
.preview-note { margin: 10px 0; color: #5c6780; font-size: 13px; }
.preview .ch-btn { display: inline-block; line-height: 34px; border: 0; cursor: pointer; }
</style>
